import classNames from "classnames";
import { get } from "lodash";
import { MdCheck, MdInfoOutline } from "react-icons/md";

const ProductCard = ({
  name,
  alias,
  info,
  link,
  showGuarantee,
  isSelected,
  selectProduct,
}) => {
  return (
    <div className="product--item" onClick={selectProduct}>
      <div
        className={classNames({
          "recommended--product": isSelected,
        })}
      >
        <div className="product--item--wrapper">
          <div className="product--item--header">
            <div className="product--item--header--top">
              <span className="--name">{name}</span>
            </div>
            <p className="product--item--description">{alias}</p>
          </div>
          <div className="product--item--info">
            <span className="product--item--info--title">{info?.title}</span>
            <div className="product--item--info--list">
              {get(info, "items", []).map((item, i) => (
                <div key={`info.item.${i}`} className="item">
                  <MdCheck size={20} />
                  <div className="content">{item.mainInfo}</div>
                  <MdInfoOutline
                    onClick={() => showGuarantee(item)}
                    size={20}
                    color="#808080"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="product--item--link" onClick={link?.onClick}>
            {link?.label}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
